import { Box, InputLabel, InputLabelProps } from "@mui/material";

interface CuvoInputLabelProps extends InputLabelProps {
  label: string;
  showRequiredIndicator?: boolean;
  showOptionalIndicator?: boolean;
}

const CuvoInputLabel = ({
  label,
  showRequiredIndicator,
  showOptionalIndicator,
}: CuvoInputLabelProps) => {
  return (
    <InputLabel>
      {label}&nbsp;
      {showRequiredIndicator && (
        <Box component="span" sx={{ color: "red", fontSize: "11px" }}>
          *
        </Box>
      )}
      {showOptionalIndicator && (
        <Box component="span" sx={{ fontSize: "11px" }}>
          (Optional)
        </Box>
      )}
    </InputLabel>
  );
};

export default CuvoInputLabel;
